import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useMount } from 'react-use'

import Thanks from '~/form/components/templates/Thanks'

interface Window {
  onSuccessFormSubmitted: () => void
}
declare var window: Window

const PageThanks: FC = () => {
  const reduxFormType = useSelector((state) => state.form.formType)

  const thanksType = useMemo(() => {
    if (reduxFormType === 'REGISTER') return 'register'
    if (reduxFormType === 'REPOST') return 'repost'

    return 'applicant'
  }, [reduxFormType])

  useMount(() => {
    // 送信完了後にウェブサイト側の関数を実行する
    if (window.onSuccessFormSubmitted) {
      window.onSuccessFormSubmitted()
    }
  })

  return (
    <>
      <Thanks type={thanksType} />
    </>
  )
}

export default PageThanks
